import { Usedata } from "./Context/Allcontext"
function Alert(){
    const {alert,ActiveAlert} = Usedata()
    return (
    <>
    {
      alert &&  (
      <section className="overley sako active">
      <div className="haye">
          <div className="sako_model">
          <form className="fooom active">
          <div className="close_oplsulet" onClick={ActiveAlert}><i className="fa-solid fa-circle-xmark"></i></div>
            <div className="image_comin">
                <img src="images/alert.svg" alt="aler_img"/>
            <p>Qaybtan shaqaa ku socota !</p>
            </div>
            </form>
          </div>
      </div>
    </section>
      ) 
    }

    </>
    )
}


export default Alert